import { tv } from 'tailwind-variants'
import { pushModal } from 'components/modal/store'
import type { FunctionalComponent } from 'vue'
import type { IHeaderProps } from '../types'
import Icon from 'components/icon'
import { twColor } from '@/utils/style'

const HeaderClass = tv({
  slots: {
    title: 'text-gray-900',
    subtitle: 'text-gray-500'
  },
  variants: {
    color: {
      white: {
        title: 'text-white',
        subtitle: 'text-white'
      }
    }
  }
})

const HeaderSm = (props: IHeaderProps) => {

  const { title, subtitle } = HeaderClass({ color: props.variant as "white" | undefined })
  const iconButtonClass = [
    'ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full transition-colors focus:outline-hidden focus-visible:outline-hidden',
    props.variant === 'white'
      ? 'text-white hover:text-white/80 focus-visible:ring-2 focus-visible:ring-white/70'
      : 'text-gray-400 hover:text-gray-600 focus-visible:ring-2 focus-visible:ring-primary-500'
  ].join(' ')

  const handleTooltipClick = async (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (!props.tooltip) {
      return
    }

    const bodyRenderer = props.tooltip.render

    const ModalBody: FunctionalComponent = () => {
      const content = bodyRenderer ? bodyRenderer() : (
        <div class="text-sm text-gray-600">tooltip</div>
      )

      return (
        <div>
          {content}
        </div>
      )
    }

    await pushModal({
      title: props.tooltip.title,
      body: ModalBody,
      hideActions: true,
      fullscreen: props.tooltip.fullscreen
    })
  }

  return (
    <div class="w-full justify-start items-center inline-flex">
      <div class="flex-col justify-center items-start gap-2 inline-flex">
        <div class="flex items-center">
          <div class={title() + " text-lg font-semibold leading-[18px]"}>{props.title}</div>
          {props.tooltip && (
            <button
              type="button"
              class={iconButtonClass}
              aria-label={`${props.tooltip.title} info`}
              onClick={handleTooltipClick}
            >
              <Icon
                src={{
                  src: async () => await import('assets/img/svg/icons/info-circle.svg?url'),
                  fill: twColor("gray-400"),
                  size: '1.25rem'
                }}
              />
            </button>
          )}
        </div>
        {props.subtitle && (
          <div class={subtitle() + ' text-sm font-normal leading-[21px]'}>
            {typeof props.subtitle === 'function' ? (props.subtitle as any)() : props.subtitle}
          </div>
        )}
      </div>
    </div>
  )
}

export default HeaderSm
